import React, { Component } from 'react';
import TextPatchConfigurator from "./TextPatchConfigurator";
import { __ } from "../Translator";
import filterCustomPatchMaterial from '../utils/filterCustomPatchMaterial';

class PatchConfigurator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: props.patchSpecification.text ? 'text' : 'image',
      patchSpecification: props.patchSpecification,
      textConfiguration: props.patchSpecification.text || TextPatchConfigurator.defaultProps.configuration,
      imageError: props.imageError,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      patchSpecification: nextProps.patchSpecification,
      imageError: nextProps.imageError,
    });
  }

  // componentWillUnmount() {
  //   this.setState({
  //     imageError : false,
  //   });
  // }

  onPatchImageChange(file) {
    // When the user closes the "Choose file" window.
    if (file === undefined) {
      return;
    }

    this.props.onImageChange(file);
  }

  resetTextConfiguration() {
    this.setState({
      textConfiguration: TextPatchConfigurator.defaultProps.configuration,
    });
  }

  onPatchTextChange(text) {
    this.props.onTextChange(text);
  }

  render() {
    return (
      <div key={this.props.patchKey}>
        <div className="patchImageForm--mainButtonsContainer">
          <button type="button" className={`btn btn-sm btn-primary ${this.state.activeTab == 'image' ? 'active': ''}`} style={{ width: '50%', }} onClick={() => {
            if (this.state.activeTab == 'image') {
              return;
            }

            this.setState({ activeTab: 'image' });
            this.resetTextConfiguration();
            // Remove the image generated from the text configuration
            this.onPatchImageChange(null);
          }}>{__('Image')}</button>

          <button type="button" className={`btn btn-sm btn-primary ${this.state.activeTab == 'text' ? 'active': ''}`} style={{ width: '50%', }} onClick={() => {
            if (this.state.activeTab == 'text') {
              return;
            }

            this.setState({ activeTab: 'text' });
            this.onPatchImageChange(null);
          }}>{__('Text')}</button>
        </div>

        {this.state.patchSpecification.image ? (
          <div className="patchImageForm__imageContainer">
            <span className="patchImageForm__clearImageBtn" onClick={() => {
              this.onPatchImageChange(null);
              this.resetTextConfiguration();
            }}>
              &times;
            </span>

            <img src={this.state.patchSpecification.image} alt="" />
          </div>
        ) : null}
        
        {this.state.activeTab === 'image' ? (
          <div>
            <input id={`file_${this.props.patchKey}`} type="file" accept="image/png, image/jpeg"  onChange={event => {
              this.onPatchImageChange(event.target.files[0]);
              this.resetTextConfiguration();
              event.target.value = '';
            }} />
            <label htmlFor={`file_${this.props.patchKey}`}>{__('Browse…')}</label>
			      {(this.state.imageError) ? <p className="patchImage__error">{__('Only PNG and JPG file under 2MB allowed.')}</p>: null	}
          </div>
        ) : null}

        {this.state.activeTab === 'text' ? (
          <TextPatchConfigurator
            configuration={this.state.textConfiguration}
            materials={filterCustomPatchMaterial(this.props.materials)}
            onChange={partialTextConfiguration => {
              this.setState({
                textConfiguration: { ...this.state.textConfiguration, ...partialTextConfiguration }
              });
            }}
            onSetClick={textConfiguration => {
              this.onPatchTextChange(textConfiguration);
            }}
          />
        ) : null}
      </div>
    );
  }
}

PatchConfigurator.defaultProps = {
  patchKey: null,
  onImageChange: console.log,
  onTextChange: console.log,
  imageError: false,
};

export default PatchConfigurator;



// WEBPACK FOOTER //
// ./src/components/PatchConfigurator.js